module.exports = __webpack_public_path__ + "bdf2ac0e8585551f26fbb4c5e909a225.svg";